import type { SVGAttributes } from 'react'
import { memo } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import type { LoadableComponent } from '@loadable/component'
import loadable from '@loadable/component'
import config from 'constants/config'
import type { ResponsiveLogoProps } from './logos/ResponsiveLuxuryEscapesLogo'

const logos: Record<string, LoadableComponent<SVGAttributes<SVGSVGElement>>> = {
  cudo: loadable(() => import('./logos/CudoGetawaysLogo')),
  cudotravel: loadable(() => import('./logos/CudoTravelLogo')),
  ouffer: loadable(() => import('./logos/OufferGetawaysLogo')),
  deals: loadable(() => import('./logos/DealsGetawaysLogo')),
  dealstravel: loadable(() => import('./logos/DealsTravelLogo')),
  livingsocial: loadable(() => import('./logos/LivingsocialGetawaysLogo')),
  treatme: loadable(() => import('./logos/TreatmeLogo')),
  treatmetravel: loadable(() => import('./logos/TreatmeTravelLogo')),
  luxuryescapes: loadable(() => import('./logos/ResponsiveLuxuryEscapesLogo')),
  scoopon: loadable(() => import('./logos/ScooponLogo')),
  leagenthub: loadable(() => import('./logos/LeAgentHubLogo')),
  leagenthub_cvfr: loadable(() => import('./logos/LeAgentHubCVFRLogo')),
}

const LogoComponent = styled.div``

interface Props extends ResponsiveLogoProps {
  className?: string
  fill?: string
  height?: number | null | string
  width?: number | null | string
}

function LogoIcon(props: Props) {
  const {
    className,
    fill,
    mobileVariant,
    tabletVariant,
    desktopVariant,
    extraLargeDesktopVariant,
    height = config.logo.iconHeight,
    width = config.logo.iconWidth,
  } = props

  const Logo = logos[config.logo.icon]

  return (
    <LogoComponent
      className={className}
      as={Logo as any}
      aria-hidden="true"
      style={{
        maxHeight: typeof height === 'number' ? rem(height) : undefined,
        maxWidth: typeof width === 'number' ? rem(width) : undefined,
      }}
      height={height}
      fill={fill || config.logo.fillColor}
      // Why the conditional spread?
      // Because only ResponsiveLuxuryEscapesLogo understands it.
      {...(config.BRAND === 'luxuryescapes' ? {
        mobileVariant,
        tabletVariant,
        desktopVariant,
        extraLargeDesktopVariant,
      } : {})}
    />
  )
}

export default memo(LogoIcon)
